import { all, call } from "redux-saga/effects";

import { faqSagas } from "./faq/faq.sagas";
import { userSagas } from "./user/user.sagas";
import { gemeindeSagas } from "./gemeinde/gemeinde.sagas";
import { reportSagas } from "./reports/report.sagas";
import { commentSagas } from "./comments/comment.sagas";

export default function* rootSaga() {
  yield all([
    call(faqSagas),
    call(userSagas),
    call(gemeindeSagas),
    call(reportSagas),
    call(commentSagas),
  ]);
}
